<div class="container">
  <h2>Gestión de Piensos</h2>

  <!-- Botón para añadir nueva marca -->
  <button (click)="nuevaMarca()" class="btn btn-primary">
    ➕ Insertar Marca
  </button>

  <!-- Formulario de inserción -->
  <form *ngIf="marcaActual" #marcaForm="ngForm" class="formulario-marca">
    <h3>Nueva Marca</h3>

    <div class="form-group">
      <label>Nombre de la marca:</label>
      <input
        [(ngModel)]="marcaActual.ttdesmar"
        name="ttdesmar"
        required
        placeholder="Introduce el nombre"
        class="form-control"
      />
    </div>

    <h4>Tipos de pienso</h4>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Nombre del tipo</th>
          <th style="width: 50px">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tipo of marcaActual.tipos; let i = index">
          <td>
            <input
              [(ngModel)]="tipo.ttdestip"
              name="tipo-{{ i }}"
              required
              placeholder="Nombre del tipo"
              class="form-control"
            />
          </td>
          <td>
            <button
              type="button"
              (click)="eliminarTipo(i)"
              class="btn btn-danger btn-sm"
            >
              🗑️
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <button type="button" (click)="agregarTipo()" class="btn btn-secondary">
      ➕ Añadir tipo
    </button>

    <div class="acciones mt-3">
      <button
        type="button"
        (click)="guardarMarca()"
        class="btn btn-success"
        [disabled]="!marcaForm.valid"
      >
        💾 Guardar
      </button>
      <button type="button" (click)="cancelar()" class="btn btn-warning">
        ❌ Cancelar
      </button>
    </div>
  </form>
</div>
